import React, {useState, useEffect} from 'react';

import {useRouter} from 'next/navigation';

import {Box, LinearProgress, Card, CardContent, Paper, Toolbar, Button, Menu, MenuItem} from '@mui/material';
import Grid from '@mui/material/Grid2';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import {useAuthStatus} from '@/app/_contexts/AuthStatusContext';


const MenuButtons = () => {
    const router = useRouter();

    const {isAuthenticated, isStaff, isSuperuser} = useAuthStatus();

    // const [bvbrcAnchorEl, setBvbrcAnchorEl] = React.useState<null | HTMLElement>(null);
    // const [violinAnchorEl, setViolinAnchorEl] = React.useState<null | HTMLElement>(null);
    const [dataAnchorEl, setDataAnchorEl] = React.useState<null | HTMLElement>(null);
    const [bvbrcAnchorEl, setBvbrcAnchorEl] = React.useState<null | HTMLElement>(null);
    const [violinAnchorEl, setViolinAnchorEl] = React.useState<null | HTMLElement>(null);
    const [protaBankAnchorEl, setProtaBankAnchorEl] = React.useState<null | HTMLElement>(null);
    const [pdbAnchorEl, setPDBAnchorEl] = React.useState<null | HTMLElement>(null);
    const [iedbAnchorEl, setIEDBAnchorEl] = React.useState<null | HTMLElement>(null);
    const [emdbAnchorEl, setEMDBAnchorEl] = React.useState<null | HTMLElement>(null);
    const [antiviraldbAnchorEl, setAntiviralDBAnchorEl] = React.useState<null | HTMLElement>(null);
    const [aiAnchorEl, setAiAnchorEl] = React.useState<null | HTMLElement>(null);

    // const bvbrcOpen = Boolean(bvbrcAnchorEl);
    // const violinOpen = Boolean(violinAnchorEl);
    const dataOpen = Boolean(dataAnchorEl);
    const bvbrcOpen = Boolean(bvbrcAnchorEl);
    const violinOpen = Boolean(violinAnchorEl);
    const protaBankOpen = Boolean(protaBankAnchorEl);
    const pdbOpen = Boolean(pdbAnchorEl);
    const iedbOpen = Boolean(iedbAnchorEl);
    const emdbOpen = Boolean(emdbAnchorEl);
    const antiviraldbOpen = Boolean(antiviraldbAnchorEl);
    const aiOpen = Boolean(aiAnchorEl);

    // const handleBvbrcButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     setBvbrcAnchorEl(event.currentTarget);
    // };
    // const handleViolinButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     setViolinAnchorEl(event.currentTarget);
    // };
    const handleDataButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setDataAnchorEl(event.currentTarget);
    };
    const handleBvbrcButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setBvbrcAnchorEl(event.currentTarget);
    };
    const handleViolinButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setViolinAnchorEl(event.currentTarget);
    };
    const handleProtaBankButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setProtaBankAnchorEl(event.currentTarget);
    };
    const handlePDBButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setPDBAnchorEl(event.currentTarget);
    };
    const handleIEDBButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setIEDBAnchorEl(event.currentTarget);
    };
    const handleEMDBButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setEMDBAnchorEl(event.currentTarget);
    };
    const handleAntiviralDBButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAntiviralDBAnchorEl(event.currentTarget);
    };
    const handleAiButtonOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAiAnchorEl(event.currentTarget);
    };

    // const handleBvbrcMenuClose = () => {
    //     setBvbrcAnchorEl(null);
    // };
    // const handleViolinMenuClose = () => {
    //     setViolinAnchorEl(null);
    // };
    const handleDataMenuClose = () => {
        setDataAnchorEl(null);
    };
    const handleBvbrcMenuClose = () => {
        setBvbrcAnchorEl(null);
        setDataAnchorEl(null);
    };
    const handleViolinMenuClose = () => {
        setViolinAnchorEl(null);
        setDataAnchorEl(null);
    };
    const handleProtaBankMenuClose = () => {
        setProtaBankAnchorEl(null);
        setDataAnchorEl(null);
    };
    const handlePDBMenuClose = () => {
        setPDBAnchorEl(null);
        setDataAnchorEl(null);
    };
    const handleIEDBMenuClose = () => {
        setIEDBAnchorEl(null);
        setDataAnchorEl(null);
    };
    const handleEMDBMenuClose = () => {
        setEMDBAnchorEl(null);
        setDataAnchorEl(null);
    };
    const handleAntiviralDBMenuClose = () => {
        setAntiviralDBAnchorEl(null);
        setDataAnchorEl(null);
    };
    const handleAiMenuClose = () => {
        setAiAnchorEl(null);
    };

    // const handleBvbrcMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     const pages = ['genome', 'protein', 'protein_structure', 'epitope'];
    //
    //     setBvbrcAnchorEl(null);
    //     router.push('/bvbrc/' + pages[Number(event.currentTarget.value)]);
    // };
    // const handleViolinMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     const pages = ['pathogen', 'vaccine', 'gene'];
    //
    //     setViolinAnchorEl(null);
    //     router.push('/violin/' + pages[Number(event.currentTarget.value)]);
    // };
    const handleDataMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    };
    const handleBvbrcMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const pages = ['genome', 'protein', 'protein_structure', 'epitope'];

        setBvbrcAnchorEl(null);
        setDataAnchorEl(null);
        router.push('/bvbrc/' + pages[Number(event.currentTarget.value)]);
    };
    const handleViolinMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const pages = ['pathogen', 'vaccine', 'gene'];

        setViolinAnchorEl(null);
        setDataAnchorEl(null);
        router.push('/violin/' + pages[Number(event.currentTarget.value)]);
    };
    const handleProtaBankMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const pages = ['protabank_basic'];

        setProtaBankAnchorEl(null);
        setDataAnchorEl(null);
        router.push('/protabank/' + pages[Number(event.currentTarget.value)]);
    };
    const handlePDBMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const pages = ['pdb_basic'];

        setPDBAnchorEl(null);
        setDataAnchorEl(null);
        router.push('/pdb/' + pages[Number(event.currentTarget.value)]);
    };
    const handleIEDBMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const pages = ['iedb_basic'];

        setIEDBAnchorEl(null);
        setDataAnchorEl(null);
        router.push('/iedb/' + pages[Number(event.currentTarget.value)]);
    };
    const handleEMDBMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const pages = ['emdb_basic'];

        setEMDBAnchorEl(null);
        setDataAnchorEl(null);
        router.push('/emdb/' + pages[Number(event.currentTarget.value)]);
    };
    const handleAntiviralDBMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const pages = ['antiviraldb_basic'];

        setAntiviralDBAnchorEl(null);
        setDataAnchorEl(null);
        router.push('/antiviraldb/' + pages[Number(event.currentTarget.value)]);
    };
    const handleAiMenuItemOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const pages = ['agentic_workflow'];

        setAiAnchorEl(null);
        router.push('/ai/' + pages[Number(event.currentTarget.value)]);
    };


    if (isAuthenticated) {
        return (
            <>
                {/*<Button*/}
                {/*    variant="outlined"*/}
                {/*    size="small"*/}
                {/*    sx={{my: 3, mx: 1}}*/}
                {/*    id="bvbrc-button"*/}
                {/*    aria-controls={bvbrcOpen ? 'bvbrc-menu' : undefined}*/}
                {/*    aria-haspopup="true"*/}
                {/*    aria-expanded={bvbrcOpen ? 'true' : undefined}*/}
                {/*    onClick={handleBvbrcButtonOnClick}*/}
                {/*>*/}
                {/*    Source 1: BV-BRC*/}
                {/*    <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>*/}
                {/*</Button>*/}
                {/*<Menu*/}
                {/*    id="bvbrc-menu"*/}
                {/*    anchorEl={bvbrcAnchorEl}*/}
                {/*    open={bvbrcOpen}*/}
                {/*    onClose={handleBvbrcMenuClose}*/}
                {/*    MenuListProps={{*/}
                {/*        'aria-labelledby': 'bvbrc-button',*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <MenuItem onClick={handleBvbrcMenuItemOnClick} value={0}>*/}
                {/*        Genome*/}
                {/*    </MenuItem>*/}
                {/*    <MenuItem onClick={handleBvbrcMenuItemOnClick} value={1}>*/}
                {/*        Protein*/}
                {/*    </MenuItem>*/}
                {/*    <MenuItem onClick={handleBvbrcMenuItemOnClick} value={2}>*/}
                {/*        Protein Structure*/}
                {/*    </MenuItem>*/}
                {/*    <MenuItem onClick={handleBvbrcMenuItemOnClick} value={3}>*/}
                {/*        Epitope*/}
                {/*    </MenuItem>*/}
                {/*</Menu>*/}

                {/*<Button*/}
                {/*    variant="outlined"*/}
                {/*    size="small"*/}
                {/*    sx={{my: 3, mx: 1}}*/}
                {/*    id="violin-button"*/}
                {/*    aria-controls={violinOpen ? 'violin-menu' : undefined}*/}
                {/*    aria-haspopup="true"*/}
                {/*    aria-expanded={violinOpen ? 'true' : undefined}*/}
                {/*    onClick={handleViolinButtonOnClick}*/}
                {/*>*/}
                {/*    Source 2: VIOLIN*/}
                {/*    <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>*/}
                {/*</Button>*/}
                {/*<Menu*/}
                {/*    id="violin-menu"*/}
                {/*    anchorEl={violinAnchorEl}*/}
                {/*    open={violinOpen}*/}
                {/*    onClose={handleViolinMenuClose}*/}
                {/*    MenuListProps={{*/}
                {/*        'aria-labelledby': 'violin-button',*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <MenuItem onClick={handleViolinMenuItemOnClick} value={0}>*/}
                {/*        Pathogen*/}
                {/*    </MenuItem>*/}
                {/*    <MenuItem onClick={handleViolinMenuItemOnClick} value={1}>*/}
                {/*        Vaccine*/}
                {/*    </MenuItem>*/}
                {/*    <MenuItem onClick={handleViolinMenuItemOnClick} value={2}>*/}
                {/*        Gene*/}
                {/*    </MenuItem>*/}
                {/*</Menu>*/}

                <Button
                    variant="outlined"
                    size="small"
                    sx={{my: 3, mx: 1}}
                    id="data-button"
                    aria-controls={dataOpen ? 'data-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={dataOpen ? 'true' : undefined}
                    onClick={handleDataButtonOnClick}
                >
                    Data
                    <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                </Button>
                <Menu
                    id="data-menu"
                    anchorEl={dataAnchorEl}
                    open={dataOpen}
                    onClose={handleDataMenuClose}
                    MenuListProps={{
                        'aria-labelledby': 'data-button',
                    }}
                >
                    <MenuItem disableGutters="true" onClick={handleDataMenuItemOnClick} value={0}>
                        <Button
                            fullWidth
                            variant="text"
                            size="small"
                            id="bvbrc-button"
                            aria-controls={bvbrcOpen ? 'bvbrc-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={bvbrcOpen ? 'true' : undefined}
                            onClick={handleBvbrcButtonOnClick}
                        >
                            Source 1: BV-BRC
                            <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                        </Button>
                        <Menu
                            id="bvbrc-menu"
                            anchorEl={bvbrcAnchorEl}
                            open={bvbrcOpen}
                            onClose={handleBvbrcMenuClose}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'top', horizontal: 'center'}}
                            MenuListProps={{
                                'aria-labelledby': 'bvbrc-button',
                            }}
                        >
                            <MenuItem onClick={handleBvbrcMenuItemOnClick} value={0}>
                                Genome
                            </MenuItem>
                            <MenuItem onClick={handleBvbrcMenuItemOnClick} value={1}>
                                Protein
                            </MenuItem>
                            <MenuItem onClick={handleBvbrcMenuItemOnClick} value={2}>
                                Protein Structure
                            </MenuItem>
                            <MenuItem onClick={handleBvbrcMenuItemOnClick} value={3}>
                                Epitope
                            </MenuItem>
                        </Menu>
                    </MenuItem>
                    <MenuItem disableGutters="true" onClick={handleDataMenuItemOnClick} value={1}>
                        <Button
                            fullWidth
                            variant="text"
                            size="small"
                            id="violin-button"
                            aria-controls={violinOpen ? 'violin-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={violinOpen ? 'true' : undefined}
                            onClick={handleViolinButtonOnClick}
                        >
                            Source 2: VIOLIN
                            <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                        </Button>
                        <Menu
                            id="violin-menu"
                            anchorEl={violinAnchorEl}
                            open={violinOpen}
                            onClose={handleViolinMenuClose}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'top', horizontal: 'center'}}
                            MenuListProps={{
                                'aria-labelledby': 'violin-button',
                            }}
                        >
                            <MenuItem onClick={handleViolinMenuItemOnClick} value={0}>
                                Pathogen
                            </MenuItem>
                            <MenuItem onClick={handleViolinMenuItemOnClick} value={1}>
                                Vaccine
                            </MenuItem>
                            <MenuItem onClick={handleViolinMenuItemOnClick} value={2}>
                                Gene
                            </MenuItem>
                        </Menu>
                    </MenuItem>
                    <MenuItem disableGutters="true" onClick={handleDataMenuItemOnClick} value={2}>
                        <Button
                            fullWidth
                            variant="text"
                            size="small"
                            id="prota-bank-button"
                            aria-controls={protaBankOpen ? 'prota-bank-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={protaBankOpen ? 'true' : undefined}
                            onClick={handleProtaBankButtonOnClick}
                        >
                            Source 3: ProtaBank
                            <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                        </Button>
                        <Menu
                            id="prota-bank-menu"
                            anchorEl={protaBankAnchorEl}
                            open={protaBankOpen}
                            onClose={handleProtaBankMenuClose}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'top', horizontal: 'center'}}
                            MenuListProps={{
                                'aria-labelledby': 'prota-bank-button',
                            }}
                        >
                            <MenuItem onClick={handleProtaBankMenuItemOnClick} value={0}>
                                ProtaBank
                            </MenuItem>
                        </Menu>
                    </MenuItem>
                    <MenuItem disableGutters="true" onClick={handleDataMenuItemOnClick} value={3}>
                        <Button
                            fullWidth
                            variant="text"
                            size="small"
                            id="pdb-button"
                            aria-controls={pdbOpen ? 'pdb-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={pdbOpen ? 'true' : undefined}
                            onClick={handlePDBButtonOnClick}
                        >
                            Source 4: PDB
                            <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                        </Button>
                        <Menu
                            id="pdb-menu"
                            anchorEl={pdbAnchorEl}
                            open={pdbOpen}
                            onClose={handlePDBMenuClose}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'top', horizontal: 'center'}}
                            MenuListProps={{
                                'aria-labelledby': 'pdb-button',
                            }}
                        >
                            <MenuItem onClick={handlePDBMenuItemOnClick} value={0}>
                                PDB
                            </MenuItem>
                        </Menu>
                    </MenuItem>
                    <MenuItem disableGutters="true" onClick={handleDataMenuItemOnClick} value={4}>
                        <Button
                            fullWidth
                            variant="text"
                            size="small"
                            id="iedb-button"
                            aria-controls={iedbOpen ? 'iedb-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={iedbOpen ? 'true' : undefined}
                            onClick={handleIEDBButtonOnClick}
                        >
                            Source 5: IEDB
                            <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                        </Button>
                        <Menu
                            id="iedb-menu"
                            anchorEl={iedbAnchorEl}
                            open={iedbOpen}
                            onClose={handleIEDBMenuClose}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'top', horizontal: 'center'}}
                            MenuListProps={{
                                'aria-labelledby': 'iedb-button',
                            }}
                        >
                            <MenuItem onClick={handleIEDBMenuItemOnClick} value={0}>
                                IEDB
                            </MenuItem>
                        </Menu>
                    </MenuItem>
                    <MenuItem disableGutters="true" onClick={handleDataMenuItemOnClick} value={5}>
                        <Button
                            fullWidth
                            variant="text"
                            size="small"
                            id="emdb-button"
                            aria-controls={emdbOpen ? 'emdb-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={emdbOpen ? 'true' : undefined}
                            onClick={handleEMDBButtonOnClick}
                        >
                            Source 6: EMDB
                            <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                        </Button>
                        <Menu
                            id="emdb-menu"
                            anchorEl={emdbAnchorEl}
                            open={emdbOpen}
                            onClose={handleEMDBMenuClose}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'top', horizontal: 'center'}}
                            MenuListProps={{
                                'aria-labelledby': 'emdb-button',
                            }}
                        >
                            <MenuItem onClick={handleEMDBMenuItemOnClick} value={0}>
                                EMDB
                            </MenuItem>
                        </Menu>
                    </MenuItem>
                    <MenuItem disableGutters="true" onClick={handleDataMenuItemOnClick} value={6}>
                        <Button
                            fullWidth
                            variant="text"
                            size="small"
                            id="antiviraldb-button"
                            aria-controls={antiviraldbOpen ? 'antiviraldb-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={antiviraldbOpen ? 'true' : undefined}
                            onClick={handleAntiviralDBButtonOnClick}
                        >
                            Source 7: AntiviralDB
                            <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                        </Button>
                        <Menu
                            id="antiviraldb-menu"
                            anchorEl={antiviraldbAnchorEl}
                            open={antiviraldbOpen}
                            onClose={handleAntiviralDBMenuClose}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'top', horizontal: 'center'}}
                            MenuListProps={{
                                'aria-labelledby': 'antiviraldb-button',
                            }}
                        >
                            <MenuItem onClick={handleAntiviralDBMenuItemOnClick} value={0}>
                                AntiviralDB
                            </MenuItem>
                        </Menu>
                    </MenuItem>
                </Menu>

                <Button
                    variant="outlined"
                    size="small"
                    sx={{my: 3, mx: 1}}
                    id="ai-button"
                    aria-controls={aiOpen ? 'ai-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={aiOpen ? 'true' : undefined}
                    onClick={handleAiButtonOnClick}
                >
                    AI
                    <KeyboardArrowDownIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                </Button>
                <Menu
                    id="ai-menu"
                    anchorEl={aiAnchorEl}
                    open={aiOpen}
                    onClose={handleAiMenuClose}
                    MenuListProps={{
                        'aria-labelledby': 'ai-button',
                    }}
                >
                    <MenuItem onClick={handleAiMenuItemOnClick} value={0}>
                        Agentic Workflow
                    </MenuItem>
                </Menu>

                <Button
                    variant="outlined"
                    size="small"
                    href={"/pubmed/pubmed"}
                    key={"/pubmed/pubmed"}
                    sx={{my: 3, mx: 1}}
                >
                    Publications
                </Button>

                <Button
                    variant="outlined"
                    size="small"
                    href={"/docs"}
                    key={"/docs"}
                    sx={{my: 3, mx: 1}}
                >
                    Docs
                </Button>
            </>
        );
    } else {
        return false;
    }
};


export default MenuButtons;
